import client from '@lib/http/client'

export const extendTrial = () =>
  client.post('payments/subscriptions/free-trial')
